import * as S from './Divider.styles';

export const Divider = () => {
  return (
    <S.Wrapper data-test-id='DividerWrapper'>
      <S.Line data-test-id='DividerLine' />
      <S.Text data-test-id='DividerText'>OR</S.Text>
      <S.Line data-test-id='DividerLine' />
    </S.Wrapper>
  );
};

Divider.displayName = 'Divider';
